module.exports = __webpack_public_path__ + "static/img/productIntroduction_04_m.a4f6cc44.jpg";